import React, { useState } from 'react';
import { UserManagerContainer } from '../UserManager.style';
import { Button, Form, FormInstance, Input, message } from 'antd';
import { ReactComponent as EmailIcon } from "../../../assets/svgs/icons/email-icon.svg";
import { ReactComponent as PasswordIcon } from "../../../assets/svgs/icons/password-icon.svg";
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import { Store } from '../../../store/Store';
import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';
import { confirmPasswordReset, resetPasswordCognito } from '../userManagementUtils';
import { useNavigate } from 'react-router-dom';

const ResetPassword = () => {
    const [isCodeSent, setIsCodeSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const formRef = React.createRef<FormInstance>();
    const navigate = useNavigate();
    const handleEmailVerification = () => {
        // Get the email from the form
        const email = formRef.current?.getFieldValue('username');
        if (!email) {
            message.warning("Please enter a valid email address.", 2);
        }
        if(!email.includes("@")) {
            message.warning("Please enter a valid email address.", 2);
            return;
        }
        resetPasswordCognito(email).then((result) => {
            setIsCodeSent(true)
        }).catch((err) => {
            message.error(err.message);
        });
    }
    const handlePasswordReset = (values: any) => {
        setLoading(true)
        confirmPasswordReset(values.username, values.code, values.password).then((result) => {
            message.success("Password reset successfully!");
            navigate('/login');
        }).catch((err) => {
            message.error(err.message);
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleLoginClick = () => {
        navigate('/login');
    }

    return (
        <UserManagerContainer>
            <div className='login__block'>
                <div className="login_inner_box">
                    <div className='login_inner_top_box'>
                        <h2>LiDAR Atlas</h2>
                    </div>
                    <div className='login_inner_middle_box'>
                        <div className='login_middle_title_box'>
                            <h2>Sign Up</h2>
                            <p>Please fill all the mandatory fields to continue</p>
                        </div>
                        <div className='login__form__block'>
                            <Form
                                ref={formRef}
                                name="normal_login"
                                className="login-form"
                                initialValues={{ remember: false }}
                                onFinish={handlePasswordReset}
                            >
                                <Form.Item
                                    name="username"
                                    rules={[{ required: true, message: 'Please Enter Email!' }]}
                                    className='form_input_field form_input_field_password'
                                >
                                    <Input size="large" prefix={<EmailIcon key="EmailIcon" />} placeholder="Registered Email*" autoComplete="email" />
                                </Form.Item>
                                <Form.Item className='sendCode_block'>
                                    <span className={`login-form-forgot user_control_btn_link ${isCodeSent ? "text_disable" : ""}`} onClick={handleEmailVerification} >
                                        Send a Code
                                    </span>
                                </Form.Item>

                                <Form.Item
                                    name="code"
                                    // rules={[{ required: true, message: 'Please Enter Email!' }]}
                                    className='form_input_field'
                                    hasFeedback
                                >
                                    <Input size="large" prefix={<EmailIcon key="EmailIcon" color="#d0d0d0" />} placeholder="Code*" autoComplete="code" disabled={!isCodeSent} />
                                </Form.Item>
                                <Form.Item
                                    name="password"
                                    rules={[{ required: true, message: 'Please Enter Password!' }]}
                                    className='form_input_field'
                                    hasFeedback
                                >
                                    <Input
                                        prefix={<PasswordIcon key="PasswordIcon" className="site-form-item-icon" />}
                                        type="password"
                                        size="large"
                                        placeholder="New Password*"
                                        autoComplete="new-password"
                                        disabled={!isCodeSent}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="new password"
                                    className='form_input_field'
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('The new password that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input
                                        prefix={<PasswordIcon key="PasswordIcon" className="site-form-item-icon" />}
                                        type="password"
                                        size="large"
                                        placeholder="Confirm Password*"
                                        autoComplete="new-password"
                                        disabled={!isCodeSent}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <Button size='large' htmlType='submit' loading={loading} className="user_control_btn" disabled={!isCodeSent}>
                                        Reset Password
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                    <div className='login_inner_bottom_box'>
                        <a href="#" className="login__link" onClick={handleLoginClick}><KeyboardBackspaceOutlinedIcon /> <span>Back to Sign In</span></a>
                    </div>
                </div>
            </div>
        </UserManagerContainer>
    );
}

export default ResetPassword;
